module.exports = __webpack_public_path__ + "static/media/1987 Kawana.ff86b335.jpg";